import { isAffiliateAttributionV2Enabled } from './affiliateRollout';
import { getOrCreateVisitorId } from './portalVisitor';

let inFlight = false;
let lastVisitKey = '';

export async function trackAffiliateLinkVisit(search = '') {
  if (!isAffiliateAttributionV2Enabled()) return false;
  const params = new URLSearchParams(search);
  const code = ['r', 'linkCode', 'affiliateLinkCode', 'aff_link']
    .map((key) => params.get(key)).find((value) => value?.trim());
  const linkCode = String(code || '').trim().toUpperCase();
  // Only an explicit link landing counts, never a stored referral or page view.
  if (!/^[A-Z0-9_-]{1,80}$/.test(linkCode)) return false;
  const visitKey = `${linkCode}:${Math.floor(Date.now() / 1800000)}`;
  if (inFlight || lastVisitKey === visitKey) return false;
  const base = String(process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');
  const visitorId = getOrCreateVisitorId();
  if (!base || !visitorId) return false;
  inFlight = true;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 4000);
  try {
    const response = await fetch(`${base}/affiliate/portal/attribution-v2/link-visits`, {
      method: 'POST', credentials: 'omit', referrerPolicy: 'no-referrer',
      headers: { 'Content-Type': 'application/json', 'X-Visitor-Id': visitorId },
      body: JSON.stringify({ linkCode }), signal: controller.signal,
    });
    if (!response.ok) return false;
    lastVisitKey = visitKey;
    return true;
  } catch (_) {
    // Analytics never blocks browsing or booking; a later navigation may retry.
    return false;
  } finally {
    clearTimeout(timeout);
    inFlight = false;
  }
}
